<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white">please wait!.. </p>
</ngx-spinner>
<div>

  <button class="fixed-button" (mouseover)="toggleSlider()" *ngIf="chaeckAdminStatus == 'Admin'"><i
      class="fa-solid fa-arrow-left"></i></button>

  <div class="right-slider" #toggleSliderRef (mouseleave)="sliderLeave('active')">
    <!-- Your sidebar content goes here -->
    <textarea class="form-control" (keyup)="updateSliderText($event)">{{sliderText}}</textarea>
  </div>

  <div class="main_content px-3 position-relative w-100">
    <div class="container-fluid py-3">
      <div class="title mb-2">
        <a (click)="addUserEmail(addEmail, 1, 1,null)" class="btn btn-success float-right">Add Email</a>
        <h2 class="base_url review_list">Reviews Pending / Completed</h2>
      </div>
      <div class="white_box shadow p-3">
        <!-- <p>{{google_feedbacks[0]|json}}</p> -->
        <select name="" class="form-control mb-3" id="" (change)="unhide($event.target.value, 0)"
          *ngIf="chaeckAdminStatus == 'Admin'">
          <option value="">Un-Hide User</option>
          <option *ngFor="let name of hideAdminData" value="{{ name?.id }}">
            {{ name?.userName }}
          </option>
        </select>
        <div class="mb-3" *ngIf="chaeckAdminStatus == 'Admin'">
          <div class="accordion mb-3" id="adminAccordion">
            <div class="card">
              <div class="card-header p-0" id="headingSubAdmin">
                <h2 class="my-0">
                  <button class="btn btn-sm btn-link" type="button" data-toggle="collapse"
                    data-target="#collapseSubAdmin" aria-expanded="true" aria-controls="collapseSubAdmin">
                    Sub Admin
                  </button>
                </h2>
              </div>
              <div id="collapseSubAdmin" class="collapse" aria-labelledby="headingSubAdmin"
                data-parent="#adminAccordion">
                <div class="card-body d-flex align-items-center flex-wrap">
                  <div *ngFor="let name of subAdminData; let i = index">
                    <div class="tabs_click">
                      <!-- <a class="btn overlay_box {{ flag == name?.id ? 'btn-success' : '' }}" (click)="getDataByUser(name?.id)">{{ name?.userName }}</a> -->
                      <div class="{{ (name?.nameColor == 1) ? 'tab_name_red' : (name?.nameColor == 2) ? 'tab_name_blue' : (name?.nameColor == 3) ? 'tab_name_green' : '' }} overlay_box btn {{
                        flag == name?.id ? 'btn-success' : ''
                      }}" (click)="getDataByUser(name?.id,name)">
                        <span class="tabName">{{ name?.userName }}</span>
                        <div>
                          <!-- {{name?.pending_payment_count_user_payment}} -->
                          <!-- {{name?.pending_payment_count}} -->
                          <!-- <i class='fa-solid fa-circle text-danger' *ngIf="name?.is_automation == 1 && name?.isAllDescriptionEmpty"></i>&nbsp; -->
                          <!-- <i class='fa-solid fa-circle text-success' *ngIf="name?.is_automation == 1 && name?.pending_payment_count_user_payment < 5"></i>&nbsp; -->
                          <!-- <i class='fa-solid fa-circle text-warning' *ngIf="name?.is_automation == 1 && name?.pending_payment_count_user_payment > 4"></i> -->
                          <i class='fa-solid fa-circle text-danger'
                            *ngIf="name?.is_automation == 1 && name?.pending_payment_count_user_payment > 9">&nbsp;</i>
                          <i class='fa-solid fa-circle text-success'
                            *ngIf="name?.is_automation == 1 && name?.pending_payment_count_user_payment < 10 && name?.reviewDescriptionCount > 0">&nbsp;</i>
                          <i class='fa-solid fa-circle text-warning'
                            *ngIf="name?.is_automation == 1 && name?.pending_payment_count_user_payment < 10 && name?.noReviewDescriptionCount == 0">&nbsp;</i>
                          <span *ngIf="name?.last_msg_sent_day != 0">({{name?.last_msg_sent_day}})</span>
                          <!-- <span *ngIf="name?.last_msg_sent_day != 0">({{name?.last_msg_sent_day}})</span> -->
                        </div>
                        &nbsp; &nbsp;
                      </div>
                      <div>
                        <a class="btn2" (click)="addUserEmail(updateEmail, name?.id, 2, name)"> <i
                            class="fas fa-pencil"></i></a>
                      </div>
                      <div>
                        <a class="btn1" (click)="hideURL(name.id, 1)"><i
                            class="fa-regular fa-circle-xmark pending_count_del_btn"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header p-0" id="headingProductShoutOut">
                <h2 class="my-0">
                  <button class="btn btn-sm btn-link collapsed" type="button" data-toggle="collapse"
                    data-target="#collapseProductShoutOut" aria-expanded="false"
                    aria-controls="collapseProductShoutOut">
                    Product
                  </button>
                </h2>
              </div>
              <div id="collapseProductShoutOut" class="collapse" aria-labelledby="headingProductShoutOut"
                data-parent="#adminAccordion">
                <div class="card-body d-flex align-items-center flex-wrap">
                  <div *ngFor="let product of productsShoutOut; let i = index">
                    <div class="tabs_click">
                      <!-- <a class="btn overlay_box {{ flag == name?.id ? 'btn-success' : '' }}" (click)="getDataByUser(name?.id)">{{ name?.userName }}</a> -->
                      <div class="tab_name_green overlay_box btn {{
                          flag == product?.id ? 'btn-success' : ''
                        }}" (click)="getFeedbackByProduct(product)">
                        <span class="tabName">{{ product?.name }}</span>
                      </div>
                      <div>
                        <a class="btn2" (click)="editProductData(updateProduct, product)"> <i
                            class="fas fa-pencil"></i></a>
                      </div>
                      <div>
                        <a class="btn1" (click)="hideURL(product.id, 1)"><i
                            class="fa-regular fa-circle-xmark pending_count_del_btn"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="btn btn-success" (click)="addProduct(addProductModal)">Add Product</div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="row">
              <div class="col-lg-12 col-md-12">
                <div *ngIf="is_clicked_name == 1 ">
                  <div class="row">
                    <div class="col-md-1">
                      <a href="{{show_review_link}}" class="float-left" target="_blank" style="color: black;"><i
                          class="fa fa-exclamation-circle" aria-hidden="true"></i></a>
                    </div>
                    <div class="col-md-10 text-center">
                      <span>{{show_client_desc}}</span>
                    </div>
                    <div class="col-md-1">
                      <a href="{{share_link}}" target="_blank" class="float-right" style="color: black;"><i
                          class="fa fa-dollar" aria-hidden="true"></i></a>
                    </div>
                  </div>
                </div>
                <br>
                <div class="goo_bg">
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">No.</th>
                        <th scope="col">Task</th>
                        <th scope="col">Tags</th>
                        <th scope="col">Type</th>
                        <th scope="col">Name</th>
                        <th scope="col">Start</th>
                        <th scope="col">Completed</th>
                        <th scope="col">Action</th>
                        <th scope="col"><i class="fa fa-refresh" aria-hidden="true" (click)="refreshGoogleData()"></i>
                        </th>
                        <!-- <th scope="col">Media</th> -->
                        <th scope="col">Approval Status</th>
                        <th scope="col">Payment Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let feedback of google_feedbacks; let i = index">
                        <th class="{{feedback.is_circle == 1 ? 'numberCircle' : 'notNumberCircle'}}" scope="row"
                          (click)="update_circle(feedback.id)">{{ googlecoundata - i }}</th>f
                        <th scope="row">
                          <a (click)="
                              sendsms(
                                phone,
                                feedback.id,
                                feedback.description,
                                feedback.review_link,
                                feedback
                              )
                            ">
                            <i class="fa-solid fa-message">
                              <span> {{ feedback.smscount }}</span>
                            </i></a>
                        </th>
                        <td>
                          <span style="cursor: pointer;" (click)="editReview(content, feedback.id, feedback)">{{
                            feedback.description?.substring(0, 20) }}</span>
                          <small class="text-danger" style="cursor: pointer;"
                            (click)="editReview(content, feedback.id, feedback)" *ngIf="!feedback.description"><i>+
                              Write
                              Task</i></small>
                        </td>
                        <td>
                          <span *ngIf="feedback.tags">{{ feedback.tags.replace('_', ' ').toUpperCase() }}</span>
                        </td>
                        <td>
                          <span *ngIf="feedback.type">{{ feedback.type.replace('_', ' ').toUpperCase() }}</span>
                        </td>
                        <td>
                          <ng-container *ngIf="feedback.feedbackmessages.length > 0">
                            <a (click)="editGoogleName(edit_google_name, feedback.id, feedback, feedback.feedbackmessages[0])"
                              class="float-right">
                              {{feedback.feedbackmessages.length > 0 ? feedback.feedbackmessages[0].name : '-'}} <br>
                              <span class="multi_goo_names">{{feedback.feedbackmessages.length > 0 ?
                                feedback.feedbackmessages[0].google_name : '-'}} </span>
                            </a>
                          </ng-container>
                        </td>
                        <td>
                          <p *ngIf="feedback.sms_time != 0"
                            [ngStyle]="{'color': feedback.is_automation_sent == 1 ? 'blue' : ''}">
                            {{ feedback.sms_time * 1000 | date : "dd/MM/yyyy" }}
                          </p>
                          <p *ngIf="feedback.sms_time == 0">
                            -
                          </p>
                        </td>
                        <td>
                          <p *ngIf="feedback.completed_time != 0">
                            {{ feedback.completed_time * 1000 | date : "dd/MM/yyyy" }}
                          </p>
                          <p *ngIf="feedback.completed_time == 0">
                            -
                          </p>
                        </td>

                        <td>
                          &nbsp;
                          <a *ngIf="
                              feedback.is_verify == 0 &&
                              chaeckAdminStatus == 'subAdmin'
                            " class="btn btn-danger">Pending</a>
                          <a (click)="imageUpload(test, feedback.id)" *ngIf="
                              feedback.is_verify == 0 &&
                              chaeckAdminStatus == 'Admin'
                            " class="btn btn-danger">Pending</a>
                          <a (click)="viewlimage(view, feedback.id)" *ngIf="feedback.is_verify == 1"
                            class="btn btn-success">Completed</a>
                        </td>
                        <td>
                          <ng-container *ngIf="feedback.is_verify == 1">
                            <i class='fa-solid fa-circle text-danger' *ngIf="feedback.is_google_review == 0"></i>&nbsp;
                            <i class='fa-solid fa-circle text-success' *ngIf="feedback.is_google_review == 1"></i>
                          </ng-container>
                        </td>
                        <td>
                          <p class="text-center"
                            *ngIf="feedback.is_approved == 0 && feedback.feedbackmessages.length == 0">
                            <i class="fas fa-check-circle"></i>
                            &nbsp;
                            <i class="fas fa-times-circle"></i>
                          </p>
                          <p class="text-center"
                            *ngIf="feedback.is_approved == 0 && feedback.feedbackmessages.length > 0 ? feedback.feedbackmessages[0].is_approved == 0 : 0">
                            <a title="Approve"
                              (click)="saveFeedbackApproval(approve_disapprove_modal, feedback.id, 1,feedback.feedbackmessages.length > 0 ? feedback.feedbackmessages[0]  : {}, 1)">
                              <i class="fas fa-check-circle"></i>
                            </a>
                            &nbsp;
                            <a title="Un-Approve"
                              (click)="saveFeedbackApproval(approve_disapprove_modal, feedback.id, 2, feedback.feedbackmessages.length > 0 ? feedback.feedbackmessages[0]  : {}, 1)">

                              <i class="fas fa-times-circle"></i>
                            </a>
                          </p>
                          <p *ngIf="feedback.is_approved == 1" class="text-center">
                            <i class="fas fa-check-circle" style="color: green;"></i>
                            &nbsp;
                            <i class="fas fa-times-circle"></i>
                          </p>
                          <p *ngIf="feedback.is_approved == 2" class="text-center">
                            <a title="Approve"
                              (click)="saveFeedbackApproval(approve_disapprove_modal, feedback.id, 1, feedback.feedbackmessages.length > 0 ? feedback.feedbackmessages[0]  : {}, 1)">
                              <i class="fas fa-check-circle"></i>
                            </a>
                            &nbsp;
                            <i class="fas fa-times-circle" style="color: red;"></i>
                          </p>
                        </td>

                        <td>
                          <p class="text-center" *ngIf="feedback.is_paid == 0 && feedback.feedbackmessages.length == 0">
                            <i class="fas fa-check-circle"></i>
                            &nbsp;
                          </p>
                          <p class="text-center"
                            *ngIf="feedback.is_paid == 0 && feedback.feedbackmessages.length > 0 ? feedback.feedbackmessages[0].is_paid == 0 : 0">
                            <a title="Approve"
                              (click)="saveFeedbackPayment(approve_disapprove_payment_modal, feedback.id, 1,feedback.feedbackmessages.length > 0 ? feedback.feedbackmessages[0]  : {}, 1)">
                              <i class="fas fa-check-circle"></i>
                            </a>
                          </p>
                          <p *ngIf="feedback.is_paid == 1" class="text-center">
                            <i class="fas fa-check-circle" style="color: green;"></i>
                          </p>
                          <p *ngIf="feedback.is_paid == 2" class="text-center">
                            <i class="fas fa-times-circle" style="color: red;"></i>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Edit Task</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <form action="">
      <div class="modal-body">
        <form [formGroup]="editFG">
          <div class="form-group">
            <label for="description">Task</label>
            <textarea class="form-control" placeholder="Write feedback" formControlName="description" rows="6"
              (keydown)="writeReview($event)">{{ edit_google_feedbacks.description }}</textarea>
          </div>
          <!-- <div class="form-group" *ngIf="!edit_google_feedbacks.product_id">
            <label for="client_remarks">Client Remarks</label>
            <input type="text" formControlName="client_remarks" class="form-control"
              placeholder="Please Enter client remarks" />
          </div>
          <div class="form-group" *ngIf="!edit_google_feedbacks.product_id">
            <label for="user_remarks">User Remarks</label>
            <input type="text" formControlName="user_remarks" class="form-control"
              placeholder="Please Enter user remarks" />
          </div> -->
          <div class="form-group">
            <label for="user_remarks">Points</label>
            <input type="text" formControlName="points" class="form-control" placeholder="Please Enter Points" />
          </div>
          <div class="form-group">
            <label for="unlimited_task">Type of Task</label>
            <select class="form-control" formControlName="type">
              <option value="normal">Normal</option>
              <option value="unlimited_many">Unlimited Many</option>
              <option value="unlimited_once">Unlimited Once</option>
            </select>
          </div>
          <div class="form-group" *ngIf="edit_google_feedbacks.limit_after_accept">
            <label for="unlimited_task">Limit After Accept</label>
            <select class="form-control" formControlName="limit_after_accept">
              <option *ngFor="let item of [1, 3, 6, 12, 24]" value="{{ item }}">{{ item }}Hr</option>
            </select>
          </div>
          <div class="form-group" *ngIf="edit_google_feedbacks.level_required">
            <label for="unlimited_task">Level Required</label>
            <select class="form-control" formControlName="level_required">
              <option *ngFor="let item of [1, 2, 3, 4, 5, 6]" value="{{ item }}">Level {{ item }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="unlimited_task">Tags</label>
            <select class="form-control" formControlName="tags">
              <option value="survey">Survey</option>
              <option value="taste_test">Taste Test</option>
              <option value="micro_job">Micro Job</option>
            </select>
          </div>
          <div class="text-center">
            <button class="btn btn-dark mx-auto" (click)="update_edit_google_feedbacks()">
              Update
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #edit_google_name let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Edit Google name </h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <form action="">
      <div class="modal-body">
        <form [formGroup]="editGoogleNameFG">
          <div class="form-group">

            <input type="text" formControlName="google_name" class="form-control"
              placeholder="Please Enter google name" />
            <ng-container *ngIf="submitted && editGoogleNameFG_v.google_name.errors">
              <p class="error-message-repair" *ngIf="editGoogleNameFG_v.google_name.errors.required">
                Google name is required!
              </p>
            </ng-container>
            <br>
            <input type="text" formControlName="google_name_link" class="form-control"
              placeholder="Please Enter Link" />

          </div>
          <div class="text-center">
            <button class="btn btn-dark mx-auto" (click)="update_google_name()">
              Update
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #phone let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Send SMS</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">X</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>

    <form [formGroup]="send_Message">
      <div class="modal-body">
        <div class="mb-3">
          <label for="type">Phone Number</label>
          <select class="right-side form-control" #selectformnames (change)="onSelectName(selectformnames.value)">
            <!-- <option value="">Select from Names</option> -->
            <option value="{{ data.phno }}" *ngFor="let data of getallname_unsent"
              [ngStyle]="{'color': data.isTimeExceed == 0 ? 'red' : data.sms_sent_count > 0 ? 'blue' :'inherit'}">
              <!-- <option value="{{ data.phno }}" *ngFor="let data of getallname_unsent" [ngStyle]="{'color': data.isTimeExceed == 0 ? 'red' :'inherit'}" > -->
              {{ data.name }} ({{ data?.complete_count }})
            </option>
          </select>
          <div class="input-group">
            <input disabled id="type" type="text" class="form-control" placeholder="Please Enter Phone No"
              formControlName="phone" oninput="this.value = this.value.replace(/[^0-9|+]/g, '');" />
            <ng-container *ngIf="submitted && send_Message_v.phone.errors">
              <p class="error-message-repair" *ngIf="send_Message_v.phone.errors.required">
                Phone is required!
              </p>
            </ng-container>
            <!-- <button class="btn btn-outline-secondary bi bi-calendar3" (click)="dp.toggle()" type="button"></button> -->
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="sendMessage()" class="btn btn-dark">Send</button>
        <!-- <button
      type="button"
      class="btn btn-outline-dark"
      (click)="modal.close('Save click')"
    >
      Send
    </button> -->
      </div>
    </form>
    <table class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Inbox ID</th>
          <th scope="col">Name</th>
          <th scope="col">Phone Number</th>
          <th scope="col">Date</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let message of feedbackMessages">
          <td>{{ message.inboxId }}</td>
          <td>{{ message.name }}</td>
          <td>{{ message.phone }}</td>
          <td class="ngb_rate_td">{{ formateDate(message.created) }}</td>
          <td>{{ message.status }}</td>
        </tr>
      </tbody>
    </table>

  </div>
</ng-template>

<ng-template #test let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Upload image</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
    <form [formGroup]="imageUploadForm">
      <p *ngIf="imagepreview != '' ">
        <img loading="lazy" class="modal_sm_img" height="50" width="50" src="{{ imgUrl }}{{ imagepreview }}" alt="" />
      </p>
      <p *ngIf="imagepreview == '' ">

        <input type="file" name="" id="" class="form-control" accept="image/*" (change)="onFileChanged($event)" />
      </p>
      <br />
      <!-- <select name="" id="" class="form-control">
        <option value="{{ data.id }}" *ngFor="let data of getallname">
          {{ data.name }}
        </option>
        <option value="">Administrator</option>
      </select> -->
      <!-- <ng-container *ngIf="submitted && imageUploadForm_v.subadminid.errors">
        <p class="error-message-repair" *ngIf="imageUploadForm_v.subadminid.errors.required">
          subadminid is required!
        </p>
      </ng-container> -->
      <br />
      <!-- <input type="text" class="form-control" placeholder="Remark" formControlName="remark" />
      <ng-container *ngIf="submitted && imageUploadForm_v.remark.errors">
        <p class="error-message-repair" *ngIf="imageUploadForm_v.remark.errors.required">
          remark is required!
        </p>
      </ng-container> -->
      <br />
      <div class="modal-footer">
        <button class="btn btn-success" (click)="verify_review_token()">
          Save
        </button>
      </div>
    </form>
  </div>
  <!-- <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')"
    >
      Close
    </button>
  </div> -->
</ng-template>

<ng-template #view let-modal class="">
  <div class="modal-header">
    <h4 class="modal-title">View image</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body text-center">
    <img loading="lazy" class="modal_sm_img" src="{{ imgUrl }}{{ imagepreview }}" alt="" />
    <br>
    <br>
    <form [formGroup]="imageUploadForm">
      <!-- <p>
        <input type="file" name="" id="" class="form-control" accept="image/*" (change)="onFileChanged($event)" />
      </p> -->
      <input type="file" name="" id="" class="form-control" accept="image/*" (change)="onFileChanged($event)" />
      <br />
      <!-- <select name="" id="" class="form-control" formControlName="subadminid">
        <option *ngFor="let name of subAdmainName" value="{{ name.id }}">
          {{ name.userName }}
        </option>
      </select> -->
      <!-- <ng-container *ngIf="submitted && imageUploadForm_v.subadminid.errors">
        <p
          class="error-message-repair"
          *ngIf="imageUploadForm_v.subadminid.errors.required"
        >
          subadminid is required!
        </p>
      </ng-container>
      <br /> -->
      <!-- <input
        type="text"
        class="form-control"
        placeholder="Remark"
        formControlName="remark"
      /> -->
      <!-- <ng-container *ngIf="submitted && imageUploadForm_v.remark.errors">
        <p
          class="error-message-repair"
          *ngIf="imageUploadForm_v.remark.errors.required"
        >
          remark is required!
        </p>
      </ng-container>
      <br /> -->
      <input type="text" class="form-control" placeholder="Link" formControlName="image_link" />
      <div class="modal-footer">
        <button class="btn btn-dark" (click)="verify_review_token()">
          Save
        </button>
      </div>
    </form>
  </div>
  <!-- <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')"
    >
      Close
    </button>
  </div> -->
</ng-template>

<ng-template #addEmail let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Add Sub-Admin Data</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <!-- <form action="" > -->
    <div class="modal-body">
      <form [formGroup]="addEmailFG">
        <div class="form-group">

          <input type="text" class="form-control" placeholder="Please Enter name" formControlName="userName" />
          <ng-container *ngIf="submitted && addEmailFG_v.userName.errors">
            <p class="error-message-repair" *ngIf="addEmailFG_v.userName.errors.required">
              Name is required!
            </p>
          </ng-container>

          <br />
          <input type="text" class="form-control" placeholder="Please Enter review link" formControlName="email" />
          <ng-container *ngIf="submitted && addEmailFG_v.email.errors">
            <p class="error-message-repair" *ngIf="addEmailFG_v.email.errors.required">
              Review link is required!
            </p>
          </ng-container>

          <br />
          <input type="text" class="form-control" placeholder="Please Enter Google place id"
            formControlName="google_place_id" />
          <ng-container *ngIf="submitted && addEmailFG_v.google_place_id.errors">
            <p class="error-message-repair" *ngIf="addEmailFG_v.google_place_id.errors.required">
              Google place id is required!
            </p>
          </ng-container>

          <br />
          <select class="form-control" formControlName="no_of_review" (change)="subonChange($event.target.value)">
            <option value="" selected disabled>
              Select Review count
            </option>
            <option *ngFor="let count of createReviewLoop(reviewCountLimit)" value="{{ count }}">
              {{ count }}
            </option>
          </select>
          <ng-container *ngIf="submitted && addEmailFG_v.no_of_review.errors">
            <p class="error-message-repair" *ngIf="addEmailFG_v.no_of_review.errors.required">
              Review count is required!
            </p>
          </ng-container>
          <br />
        </div>
        <div class="text-center">
          <button class="btn btn-dark mx-auto" (click)="add_user_email_data()">
            Add
          </button>
        </div>
      </form>
    </div>
    <!-- </form> -->
  </div>
</ng-template>

<ng-template #updateEmail let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Edit Sub-Admin Data</h4>

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
    </div>
    <form action="">
      <div class="modal-body">
        <form [formGroup]="updateEmailFG">
          <div class="form-group">
            <div>
              <a href="{{share_link}}" target="_blank">Click to open URL</a>&nbsp; &nbsp;
              <i title="Click to copy" style="cursor: pointer;" class="fa fa-clipboard"
                [cdkCopyToClipboard]="share_link" aria-hidden="true" (click)="copyToClipboardMessage()"></i>
            </div>
            <br>

            <input type="radio" [(ngModel)]="name_color_checked" value="0"
              formControlName="name_color"><label>&nbsp;Grey</label>&nbsp; &nbsp; &nbsp;
            <input type="radio" [(ngModel)]="name_color_checked" value="1"
              formControlName="name_color"><label>&nbsp;Red</label>&nbsp; &nbsp; &nbsp;
            <input type="radio" [(ngModel)]="name_color_checked" value="2"
              formControlName="name_color"><label>&nbsp;Blue</label>&nbsp; &nbsp; &nbsp;
            <input type="radio" [(ngModel)]="name_color_checked" value="3"
              formControlName="name_color"><label>&nbsp;Green</label>&nbsp; &nbsp; &nbsp;
            <br>

            <!-- <input type="checkbox" formControlName="is_automation"> -->
            <input [(ngModel)]="is_automation_checked" type="checkbox" formControlName="is_automation">
            <label for="vehicle1">&nbsp;Automation</label> &nbsp; &nbsp;

            <input [(ngModel)]="is_twice_automation_checked" type="checkbox" formControlName="is_twice_automation">
            <label for="vehicle2">&nbsp;Twice Automation</label> &nbsp; &nbsp;

            <input [(ngModel)]="is_bypass_slot_checked" type="checkbox" formControlName="is_bypass_slot">
            <label for="vehicle3">&nbsp;Bypass Slot Payment</label> &nbsp; &nbsp;

            <br />
            <input type="text" formControlName="email" class="form-control" placeholder="Please Enter review link" />
            <ng-container *ngIf="submitted && updateEmailFG_v.email.errors">
              <p class="error-message-repair" *ngIf="updateEmailFG_v.email.errors.required">
                Review link is required!
              </p>
              <!-- <p class="error-message-repair" *ngIf="updateEmailFG_v.email.errors.email">
                Enter Valid Email.
            </p> -->
            </ng-container>

            <br />
            <input type="text" formControlName="google_place_id" class="form-control" placeholder="" />
            <ng-container *ngIf="submitted && updateEmailFG_v.google_place_id.errors">
              <p class="error-message-repair" *ngIf="updateEmailFG_v.google_place_id.errors.required">
                Google place id required!
              </p>
            </ng-container>

            <br />
            <input type="text" formControlName="client_desc" class="form-control" placeholder="" />
            <ng-container *ngIf="submitted && updateEmailFG_v.client_desc.errors">
              <p class="error-message-repair" *ngIf="updateEmailFG_v.client_desc.errors.required">
                Description is required!
              </p>
            </ng-container>

            <br />
            <select class="form-control" formControlName="no_of_review" (change)="subonChange($event.target.value)">
              <option value="" selected disabled>
                Select Review count
              </option>
              <option *ngFor="let count of createReviewLoop(reviewCountLimit)" value="{{ count }}">
                {{ count }}
              </option>
            </select>
            <!-- <ng-container *ngIf="submitted && updateEmailFG_v.no_of_review.errors">
              <p class="error-message-repair" *ngIf="updateEmailFG_v.no_of_review.errors.required">
                Review count is required!
              </p>
            </ng-container> -->
            <br />
          </div>
          <div class="text-center">
            <button class="btn btn-dark mx-auto" (click)="update_user_email_data()">
              Update
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #updateProduct let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Edit Product Data</h4>

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
    </div>
    <form action="">
      <div class="modal-body">
        <form [formGroup]="updateProductFG">
          <div class="form-group">
            <label for="no_of_review">Add More Tasks</label>
            <select class="form-control" formControlName="no_of_review">
              <option value="" selected disabled>
                Select Task Count
              </option>
              <option *ngFor="let count of createReviewLoop(reviewCountLimit)" value="{{ count }}">
                {{ count }}
              </option>
            </select>
          </div>
          <div class="text-center">
            <button class="btn btn-dark mx-auto" (click)="update_product_data()">
              Update
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #approve_disapprove_modal let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Aprroval Status</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <div class="modal-body">
      <div class="text-center">
        <h2>Are you sure want to {{is_approved_message}}</h2>
      </div>
      <div class="text-center">
        <button class="btn btn-dark mx-auto"
          (click)="saveFeedbackApproval(approve_disapprove_modal, gfbid, is_approved,feedbackmessagesObj, 2)">
          Yes
        </button> &nbsp; &nbsp;
        <button class="btn btn-dark mx-auto" (click)="modal.dismiss('Cross click')">
          No
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #approve_disapprove_payment_modal let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Payment Status</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <div class="modal-body">
      <div class="text-center">
        <h2>Are you sure want to {{is_paid_message}}</h2>
      </div>
      <div class="text-center">
        <button class="btn btn-dark mx-auto"
          (click)="saveFeedbackPayment(approve_disapprove_payment_modal, gfbid, is_paid,feedbackmessagesObj, 2)">
          Yes
        </button> &nbsp; &nbsp;
        <button class="btn btn-dark mx-auto" (click)="modal.dismiss('Cross click')">
          No
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addProductModal let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Products</h4>
      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
    </div>
    <div class="modal-body">
      <!-- Search Section -->
      <div class="mb-3">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Search products..." (input)="onSearchProduct($event)" />
          <button class="btn btn-outline-secondary" type="button" (click)="clearSearch()">
            <i class="fas fa-times"></i> Clear
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Product Name</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of products; let i = index">
              <td>{{ (page - 1) * limit + i + 1 }}</td>
              <td>{{ product.name }}</td>
              <td>
                <img *ngIf="product.primaryImage" [src]="imageUrl + product.primaryImage" alt="{{ product.name }}"
                  class="img-thumbnail" style="width: 50px; height: 50px; object-fit: cover;">
                <span *ngIf="!product.primaryImage" class="text-muted">No Image</span>
              </td>
              <td>
                <button class="btn btn-sm btn-success" (click)="assignProductReview(product)">Select</button>
              </td>
            </tr>
            <tr *ngIf="!products || products.length === 0">
              <td colspan="4" class="text-center">No products found</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <nav *ngIf="totalPages > 1" aria-label="Product pagination">
        <ul class="pagination justify-content-center">
          <li class="page-item" [class.disabled]="page === 1">
            <a class="page-link" (click)="onPageChange(page - 1)">Previous</a>
          </li>
          <li class="page-item" *ngFor="let p of [page, page + 1, page + 2]; let i = index" [class.active]="page === p">
            <a class="page-link" (click)="onPageChange(p)">{{ p }}</a>
          </li>
          <li class="page-item" [class.disabled]="page === totalPages">
            <a class="page-link" (click)="onPageChange(page + 1)">Next</a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Close</button>
    </div>
  </div>
</ng-template>